import * as React from "react";
import {
  SettingsContainer,
  SettingsContentContainer,
  SettingsHeader,
} from "styles/Settings";
import SettingsMenu from "components/pages/Settings/SettingsMenu";
import { RightOutlined } from "@ant-design/icons";
import Logo from "../images/lingdon-LOGO-white.svg";
import { Link, Route, Switch } from "react-router-dom";
import RaceliveSettings from "./RaceliveSettings";
import TopMenuSettings from "./TopMenuSettings";

const pages: Record<string, [string, string]> = {
  racelive: ["/settings/racelive", "直播成绩"],
  scan_detail: ["/settings/scan_detail", "扫描明细"],
  daily_record: ["/settings/daily_record", "每日归返"],
  daily_total: ["/settings/daily_total", "每日统计"],
  device_list: ["/settings/device_list", "踏板清单"],
  device_connection: ["/settings/device_connection", "踏板连线状态"],
  train_record: ["/settings/train_record", "踏板扫描设定"],
  device_order: ["/settings/device_order", "踏板命令"],
  top_menu: ["/settings/top_menu", "菜单设定"],
};

const Settings = () => {
  const [isOpen, setOpen] = React.useState(true);
  const [currentPage, setPage] = React.useState("直播成绩");
  const onMenuClick = () => {
    setOpen(!isOpen);
  };
  const onMenuSelect = (key: keyof typeof pages) => {
    setPage(pages[key][1]);
  };
  return (
    <div>
      <SettingsHeader>
        <Link to="/">
          <img src={Logo} alt="lingdong-logo" />
          <span className="primary">岭东资讯</span>
        </Link>
        <div className="separator"></div>
        <span>設定頁面</span>
        <RightOutlined className="arrow" />
        <span>{currentPage}</span>
      </SettingsHeader>
      <SettingsContentContainer isOpen={isOpen}>
        <SettingsMenu
          isOpen={isOpen}
          onClick={onMenuClick}
          pages={pages}
          onSelect={onMenuSelect}
        />
        <SettingsContainer>
          <Switch>
            <Route path="/settings/racelive">
              <RaceliveSettings />
            </Route>
            <Route path="/settings/scan_detail">
              <div>scan_detail</div>
            </Route>
            <Route path="/settings/daily_record">
              <div>daily_record</div>
            </Route>
            <Route path="/settings/daily_total">
              <div>daily_total</div>
            </Route>
            <Route path="/settings/device_list">
              <div>device_list</div>
            </Route>
            <Route path="/settings/device_connection">
              <div>device_connection</div>
            </Route>
            <Route path="/settings/train_record">
              <div>train_record</div>
            </Route>
            <Route path="/settings/device_order">
              <div>device_order</div>
            </Route>
            <Route path="/settings/top_menu">
              <TopMenuSettings />
            </Route>
          </Switch>
        </SettingsContainer>
      </SettingsContentContainer>
    </div>
  );
};

export default Settings;
